import { FC, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { Typography, Divider } from '@material-ui/core';
import useStore from '@hooks/useStore';
import { useStyles } from './styles';
import logo from '@assets/images/logo-accountpayables.svg';

interface CheckoutLayoutProps {
  children: ReactNode;
}

const CheckoutLayout: FC<CheckoutLayoutProps> = ({ children }) => {
  const { links } = useStore();
  const { secondaryColor } = links.coBrandingConfig;
  const { businessName } = links.accountInfo;
  const classes = useStyles({ secondaryColor });

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <div className={classes.headerContent}>
          <div className={classes.headerLeft}>
            <img src={logo} alt="Oyster by Yaydoo" className={classes.logo} />
            {businessName && (
              <>
                <Divider orientation="vertical" flexItem />
                <Typography variant="h6" className={classes.businessName}>
                  {businessName}
                </Typography>
              </>
            )}
          </div>
          <div className={classes.headerRight}></div>
        </div>
      </header>
      <main className={classes.main}>{children}</main>
      <footer className={classes.footer}>
        <div className={classes.footerContent}>
          <Typography component="p" className={classes.footerText}>
            Powered by <span className={classes.oysterText}>Oyster</span>
          </Typography>
        </div>
      </footer>
    </div>
  );
};

export default observer(CheckoutLayout);
